enum HeaderCallToAction {
  LOGIN,
  SIGN_UP,
  NONE,
}

export { HeaderCallToAction };
